import { BypassBlock } from '../BypassBlock';
import s from './styles.scss';
import cx from 'classnames';

export interface LayoutItemProps {
  children?: React.ReactNode;
}

type LayoutItem = React.ReactElement<
  typeof TopBar | typeof SideBar | typeof Main | typeof BottomBar
>;

export interface LayoutProps {
  children: LayoutItem[];
  className?: string;
}

const TopBar = ({ children }: LayoutItemProps): JSX.Element => (
  <div className={s.topBar}>
    <BypassBlock />
    {children}
  </div>
);

const SideBar = ({ children }: LayoutItemProps): JSX.Element => (
  <aside className={s.sideBar}>{children}</aside>
);

const Main = ({ children }: LayoutItemProps): JSX.Element => (
  <main id="main-content" tabIndex={-1} className={s.main}>
    {children}
  </main>
);

const BottomBar = ({ children }: LayoutItemProps): JSX.Element => (
  <div className={s.bottomBar}>{children}</div>
);

const Layout = ({ children, className }: LayoutProps): JSX.Element => (
  <div className={cx(s.layout, className)}>{children}</div>
);

Layout.TopBar = TopBar;
Layout.SideBar = SideBar;
Layout.Main = Main;
Layout.BottomBar = BottomBar;

export { Layout };
